import { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext, EMPTY_OBJECT } from 'commons-ui';
import useService from '../../../useService';
import { dehydrateFormData } from '../../utils/formDataParser';
import { TMemeDehydratedData, TSubmitMemeData } from '../../utils/types';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history = useHistory();
	const { requestCreateMeme } = useService();

	const createMeme = (createdData: TMemeDehydratedData) => {
		setShowLoader(true);

		requestCreateMeme(app.appName, createdData).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || 'Error occured while creating the meme', { type: 'error' });
					setShowLoader(false);
					return;
				}

				showAlert('Meme created');
				setShowLoader(false);
				history.goBack();
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: TSubmitMemeData) => {
		createMeme(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data: EMPTY_OBJECT, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
